import React, { useState, ChangeEventHandler } from 'react';
import classes from './agreeSendCardInfo.module.scss';

type Props = {
	isAgreeSendCardInfo: boolean;
	handleChangeAgreeCheckValue: ChangeEventHandler<HTMLInputElement>;
};
export const AgreeSendingCardInfo = (props: Props) => {
	const { isAgreeSendCardInfo, handleChangeAgreeCheckValue } = props;
	return (
		<div className={`form-box ${classes.agreeSendCardInfo}`}>
			<div className="form-input">
				<div>
					当サイトは3Dセキュア(本人認証サービス)を導入しています。不正利用防止のため、本人認証用にカード会社へ個人情報を連携させていただきます。ご同意の上、「次へ」ボタンを押してください
				</div>
				<div className={`check-box ${classes.agreeSendCardInfo}`}>
					<ul>
						<li>
							<label className={`check-label ${isAgreeSendCardInfo ? 'is-active' : ''}`}>
								<input
									type="checkbox"
									id="isAgreeSendCardInfo"
									checked={isAgreeSendCardInfo}
									onChange={handleChangeAgreeCheckValue}
								/>
								同意する
							</label>
						</li>
					</ul>
				</div>
			</div>
		</div>
	);
};
